import { DashboardWidget, DashboardWidgetFC, useDashboardWidget } from '@frontend/grid-dashboard';
import { useTranslation } from '@frontend/i18n';
import { usePaymentsModalButton, PaymentRequestModal } from '@frontend/payments-collection-flow';
import { REQUEST_ORIGINS } from '@frontend/person-invoice-create';

/**
 * @dashboard-widget
 *
 * id: add-invoice
 * title: New Invoice
 * description: Quickly create a new invoice and collect payments.
 * icon: payments
 */
export const AddInvoiceWidget: DashboardWidgetFC = () => {
  const { t } = useTranslation('payments');
  const { widgetTrackingId } = useDashboardWidget();
  const { triggerProps, paymentRequestModalProps } = usePaymentsModalButton();

  return (
    <>
      <DashboardWidget.ActionButton
        title={t('Payment Request')}
        trackingId={widgetTrackingId('action')}
        iconName='add'
        {...triggerProps}
      />
      <PaymentRequestModal {...paymentRequestModalProps} origin={REQUEST_ORIGINS.HOME_PAGE_QUICK_ACTION} />
    </>
  );
};

AddInvoiceWidget.config = {
  size: 'tiny-slim',
  feature: 'payments',
};
